import { ApplicationRef, Injector, afterNextRender, runInInjectionContext } from '@angular/core';
import { firstValueFrom, race, timer } from 'rxjs';
import { filter, take } from 'rxjs/operators';

/** Waits for Angular hydration to settle, then runs the callback once. */
export function runAfterHydration(injector: Injector, callback: () => void | Promise<void>): void {
  runInInjectionContext(injector, () => {
    afterNextRender(() => {
      const appRef = injector.get(ApplicationRef);

      void (async () => {
        try {
          await firstValueFrom(
            race(
              appRef.isStable.pipe(filter(Boolean), take(1)),
              timer(800)
            )
          );
        } catch {
          // Proceed even if stability never emits.
        }

        await callback();
      })();
    });
  });
}

/** Reverts a GSAP context without throwing when Angular already reconciled the DOM. */
export function safeGsapRevert(ctx: { revert?: () => void } | null | undefined): void {
  try {
    ctx?.revert?.();
  } catch {
    // GSAP may try to remove nodes Angular already detached during hydration/teardown.
  }
}
